var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.changes.changelog),function(change){return _c('div',{key:change.id,staticClass:"container"},[_c('VueMarkdown',{staticClass:"md",staticStyle:{"text-align":"center"},attrs:{"loading":"lazy","source":change.md}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }